import { createSelector } from 'reselect';
import { getAfyaImaraState } from './index';
import { FORM_STATUS, API_CALL_STATUS } from '../../reducers/status';

// All medical history selectors
export const getMedicalHistory = createSelector(getAfyaImaraState, (state) => state.medicalHistory);
export const getMedicalHistoryForm = createSelector(getMedicalHistory, (medicalHistory) => medicalHistory.form);
export const getMedicalHistoryFormValid = createSelector(
    getMedicalHistory,
    (medicalHistory) => medicalHistory.formStatus === FORM_STATUS.VALID,
);
export const getIsApiPending = createSelector(
    getMedicalHistory,
    (medicalHistory) => medicalHistory.formStatus === API_CALL_STATUS.PENDING,
);

export const getApiCallStatus = createSelector(
    getMedicalHistory,
    (medicalHistory) => medicalHistory.apiCallStatus
);

const makeGetFieldForm = (fieldId) => createSelector(getMedicalHistoryForm, (form) => form[fieldId]);
export const getRelationshipValue = makeGetFieldForm('relationship');
export const getNameValue = makeGetFieldForm('name');
export const getIdBirthCertificateValue = makeGetFieldForm('idBirthCertificate');
export const getDateOfOnsetValue = makeGetFieldForm('dateOfOnset');
export const getDiagnosisValue = makeGetFieldForm('diagnosis');
export const getDateOfLastEpisodeValue = makeGetFieldForm('dateOfLastEpisode');
export const getTreatmentValue = makeGetFieldForm('pastCurrentTreatment');
export const getAdditionalDetailsValue = makeGetFieldForm('additionalDetails');
export const getNoneOfTheAboveValue = makeGetFieldForm('noneOfTheAbove');
export const getMedicalHistoryData = createSelector(getMedicalHistory, (medicalHistory) => medicalHistory.medicalHistory);